module.exports = __webpack_public_path__ + "img/draft-marks-original.0fab8ba0.webp";